const IconListItemBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g>
      <g>
        <g>
          <rect width="24" height="24" fill="#333" />
          <rect x="2" y="2" width="20" height="20" fill="#ffd400" />
          <rect x="10" y="4" width="10" height="4" fill="#333" />
          <rect x="4" y="4" width="4" height="4" fill="#333" />
        </g>
      </g>
    </g>
  </svg>
);

export default IconListItemBlockIcon;
